export interface UniverseRowStats {
  countries: number;
  constituents: number;
}

/** Minimal shape of a universe-security item this needs — kept structural so
 *  callers can pass the `useUniverseSecurityItems` result directly. */
interface SecurityLike {
  portfolioIds: Array<string>;
  country: string;
}

// Per-index stats (distinct countries + constituent count), keyed by portfolio
// id. Shared by the universe index picker and the benchmark picker so both
// dropdowns show the same "N Countries • N Constituents" meta from one pass
// over the security-items payload.
export function computeUniverseStats(
  allSecurities: ReadonlyArray<SecurityLike> | undefined,
): Map<string, UniverseRowStats> {
  const stats = new Map<string, UniverseRowStats>();
  if (!allSecurities) return stats;

  const grouped = new Map<string, Set<string>>();
  const counts = new Map<string, number>();

  for (const sec of allSecurities) {
    for (const uid of sec.portfolioIds) {
      if (!grouped.has(uid)) {
        grouped.set(uid, new Set());
        counts.set(uid, 0);
      }
      grouped.get(uid)!.add(sec.country);
      counts.set(uid, (counts.get(uid) ?? 0) + 1);
    }
  }

  for (const [uid, countrySet] of grouped) {
    stats.set(uid, {
      countries: countrySet.size,
      constituents: counts.get(uid) ?? 0,
    });
  }

  return stats;
}
